




















































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Moment from "moment-timezone";
import ControlDeviceDto from '@/store/entities/Common/controlDeviceDto';
import commandHelper from '@/lib/Common/commonhelper';
import MeterTimingPO from "@/store/entities/devices/metertimingpo";

/**
 * 控制数据
 */
class dataDto extends ControlDeviceDto {
    meterNoList: string;
    maxPoint: number = 1;
    aeskey: string = "00000000000000000000000000000000";
    masterIp: string;
    masterPort: number;
    standbyIp: string;
    standbyPort: number;
    apn: string = "cmnet";
    /**第一回路恶性负载 */
    firstLoopPower: number = 0;
    /**第一回路第一次合闸恢复时间 */
    firstloopfirston: number;
    /**第一回路第二次合闸恢复时间 */
    firstloopsecondon: number;
    /**第一回路第三次合闸恢复时间 */
    firstloopthirdon: number;
    /**
     * 第二回路恶性负载功率
     */
    secondLoopPower: number = 0;
    /**第二回路第一次合闸恢复时间 */
    secondloopfirston: number;
    /**第二回路第二次合闸恢复时间 */
    secondloopsecondon: number;
    /**第二回路第三次合闸恢复时间 */
    secondloopthirdon: number;
    /**星期 */
    week: number = 0;
}

@Component({
    components: { TreeSelect },
})
export default class SettingParams extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({ type: Array, default: [] }) meterlist: Array<any>;
    @Prop({ type: Array, default: [] }) meternolist: Array<any>;
    cidlist: Array<any> = [];
    loading: boolean = false;
    /**序号 */
    indexnum: number = 1;
    sendparamsDto: dataDto = new dataDto();
    /**
     * 回路信息
     */
    looplist: any = [
        { value: 1, label: "回路一" },
        { value: 2, label: "回路二" },
    ];
    /**
     * 开关信息
     */
    onofflist: any = [
        { value: 1, label: "关" },
        { value: 2, label: "开" },
    ]
    /**时点 */
    timepoinglist: any = [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
        { value: 5, label: "5" },
        { value: 6, label: "6" },
    ];
    /**
     * 星期
     */
    weeklist: any = [
        { value: 1, label: "周一" },
        { value: 2, label: "周二" },
        { value: 3, label: "周三" },
        { value: 4, label: "周四" },
        { value: 5, label: "周五" },
        { value: 6, label: "周六" },
        { value: 7, label: "周日" }
    ];
    /**
     * 定时消息
     */
    meterTimingPO: MeterTimingPO = new MeterTimingPO();
    create() { }
    created() {
        this.organizationlist();
        this.sendparamsDto.dt = 167;
        this.sendparamsDto.sendCycle = 1;
        this.sendparamsDto.sendUnit = 2;
        this.sendparamsDto.startTime = Moment().add(5, "minute").format("YYYY-MM-DD HH:mm:ss");
        this.sendparamsDto.operatorRang = 3;
        this.sendparamsDto.firstLoopPower = 0;
        this.sendparamsDto.firstloopfirston = 1;
        this.sendparamsDto.firstloopsecondon = 1;
        this.sendparamsDto.firstloopthirdon = 1;
        this.sendparamsDto.secondLoopPower = 0;
        this.sendparamsDto.secondloopfirston = 1;
        this.sendparamsDto.secondloopsecondon = 1;
        this.sendparamsDto.secondloopthirdon = 1;
    }
    RangeInteger() {
        let value: string = '';
        for (let i = 0; i < 32; i++) {
            //console.log(value)
            value = value + Math.ceil(Math.random() * 9).toString();
        }
        // const range = max - min;
        // const value = Math.floor(Math.random() * range) + min;
        return value;
    }
    generate() {
        this.sendparamsDto.aeskey = this.RangeInteger();
    }
    /**列数据 */
    columnsdata: any[] = [];
    /**列信息 */
    columns = [
        {
            title: "序号",
            key: "indexNo",
            width: 130
        },
        {
            title: "回路",
            key: "loopNum",
            render: (h: any, params: any) => {
                return h("RadioGroup", {
                    props: {
                        value: params.row.loopNum,
                    },
                    domProps: {
                        value: params.row.loopNum,
                    },
                    on: {
                        input: e => {
                            this.setData(e, "loopNum", params.index);
                        },
                    },
                }, this.looplist.map((item) => {
                    return h('Radio', { // 下拉框的值
                        props: { label: item.value }
                    }, item.label)
                }));
            },
        },
        {
            title: "星期",
            key: "weekDay",
            render: (h: any, params: any) => {
                return h('Select', {
                    props: {
                        filterable: true,
                        value: params.row.weekDay, // 获取选择的下拉框的值
                        size: 'small',
                        transfer: true,
                    },
                    on: {
                        'on-change': e => {
                            this.setData(e, "weekDay", params.index);
                        }
                    }
                }, this.weeklist.map((item) => { // this.productTypeList下拉框里的data
                    return h('Option', { // 下拉框的值
                        props: {
                            value: item.value,
                            label: item.label
                        }
                    })
                }))
            },
        },
        {
            title: "时序",
            key: "timePoint",
            render: (h: any, params: any) => {
                return h('Select', {
                    props: {
                        filterable: true,
                        value: params.row.timePoint, // 获取选择的下拉框的值
                        size: 'small',
                        transfer: true,
                    },
                    on: {
                        'on-change': e => {
                            this.setData(e, "timePoint", params.index);
                        }
                    }
                }, this.timepoinglist.map((item) => { // this.productTypeList下拉框里的data
                    return h('Option', { // 下拉框的值
                        props: {
                            value: item.value,
                            label: item.label
                        }
                    })
                }))
            },
        },
        {
            title: "时间",
            key: "timeStr",
            render: (h, params) => {
                return h('TimePicker', {
                    props: {
                        value: params.row.timeStr, // 获取选择的下拉框的值
                        size: 'small',
                        transfer: true,
                        filterable: false,
                        format: "HH:mm"
                    },
                    on: {
                        'on-change': e => {
                            this.setData(e, "timeStr", params.index);
                        }
                    }
                })
            }
        },
        {
            title: "开关",
            key: "onOff",
            render: (h: any, params: any) => {
                return h("RadioGroup", {
                    props: {
                        value: params.row.onOff,
                    },
                    domProps: {
                        value: params.row.onOff,
                    },
                    on: {
                        input: e => {
                            this.setData(e, "onOff", params.index);
                        },
                    },
                }, this.onofflist.map((item) => {
                    return h('Radio', { // 下拉框的值
                        props: { label: item.value }
                    }, item.label)
                }));
            },
        },
        {
            title: this.L("Actions"),
            key: "Actions",
            width: 160,
            fixed: "right",
            sortId: 999,
            render: (h: any, params: any) => {
                return h("div", [
                    h(
                        "Button",
                        {
                            props: {
                                type: "error",
                                size: "small",
                            },
                            style: {
                                marginRight: "5px",
                            },
                            on: {
                                click: async () => {
                                    this.$Modal.confirm({
                                        title: this.L("Tips"),
                                        content: this.L("DeleteConfirm"),
                                        okText: this.L("Yes"),
                                        cancelText: this.L("No"),
                                        onOk: async () => {
                                            this.delRow(params.row)
                                        },
                                    });
                                },
                            },
                        },
                        "删除行"
                    ),
                ]);
            },
        },
    ];
    /**
     * 设置数据
     * @param value 
     * @param key 
     * @param index
     */
    setData(value: any, key: string, index: number) {
        switch (key) {
            case "loopNum":
                this.columnsdata[index].loopNum = value;
                break;
            case "weekDay":
                this.columnsdata[index].weekDay = value;
                break;
            case "timePoint":
                this.columnsdata[index].timePoint = value;
                break;
            case "timeStr":
                this.columnsdata[index].timeStr = value;
                break;
            case "onOff":
                this.columnsdata[index].onOff = value;
                break;
        }
    }
    /**增加行 */
    addrow() {
        this.columnsdata.forEach(item => {
            if (!('meterId' in item) || item.meterId == "") {
                item.deviceId = this.meterlist[0];
            }
        })
        let info = new MeterTimingPO();
        info.indexNo = this.indexnum + 1;
        info.deviceId = this.meterlist[0];
        this.indexnum++;
        this.columnsdata.push(info)
    }
    /**删除行 */
    delRow(params: any) {
        this.columnsdata = this.columnsdata.filter(ele => {
            return ele.indexNo != params.indexNo;
        });
    }
    /**检测数据合法性 */
    checkTiming() {
        this.columnsdata.forEach(ele => {
            ele.deviceId = this.sendparamsDto.deviceIds[0];
            if (!ele.loopNum) {
                this.$Message.warning("序号" + ele.indexNo + "未选择回路");
                return false;
            }
            if (!ele.weekDay) {
                this.$Message.warning("序号" + ele.indexNo + "未选择星期");
                return false;
            }
            if (!ele.timePoint) {
                this.$Message.warning("序号" + ele.indexNo + "未选择时序");
                return false;
            }
            if (!ele.timeStr) {
                this.$Message.warning("序号" + ele.indexNo + "未选择时间");
                return false;
            }
        });
        return true;
    }
    /**设置定时数据 */
    async setTiming() {
        if (this.checkTiming) {
            console.log(this.columnsdata)
            let res = await this.$store.dispatch({
                type: "metertiming/insertTimingList",
                data: this.columnsdata,
            });
            this.$Modal.info({
                title: this.L("Tips"),
                content: res,
            });
        }
    }
    /**
     * 启动采集器上报
     */
    async startCollectorPort() {
        this.sendparamsDto.operatorType = 198;
        this.sendparamsDto.isStart = true;
        this.sendparamsDto.transferType = 34;
        let i: number = 0;
        //let max:number = this.sendparamsDto.maxPoint;
        this.sendparamsDto.infoPoint = [];
        for (i = 0; i < this.sendparamsDto.maxPoint; i++) {
            this.sendparamsDto.infoPoint.push(i + 1);
        }
        let res = await this.$store.dispatch({
            type: "meter/meterControl",
            data: this.sendparamsDto,
        });
        this.$Modal.info({
            title: this.L("Tips"),
            content: res,
        });
    }
    /**
     * 停止采集器上报
     */
    async stopCollectorPort() {
        this.sendparamsDto.operatorType = 198;
        this.sendparamsDto.isStart = false;
        let res = await this.$store.dispatch({
            type: "meter/meterControl",
            data: this.sendparamsDto,
        });
        this.$Modal.info({
            title: this.L("Tips"),
            content: res,
        });
    }
    /**
     * 设置心跳间隔及上报周期
     */
    async setHeartInter() {
        if (this.sendparamsDto.heartInter == null || this.sendparamsDto.heartInter == 0) {
            this.$Modal.info({
                title: this.L("Tips"),
                content: this.L("NoHeartInter"),
            });
            return;
        };
        this.sendparamsDto.operatorType = 199;
        let res = await this.$store.dispatch({
            type: "meter/meterControl",
            data: this.sendparamsDto,
        });
        this.$Modal.info({
            title: this.L("Tips"),
            content: res,
        });
    }
    /**
     * 设置离散时间
     */
    async setRange() {
        if (this.sendparamsDto.sendRang == null || this.sendparamsDto.sendRang == 0) {
            this.$Modal.info({
                title: this.L("Tips"),
                content: this.L("NoDispersedTime"),
            });
            return;
        }
        this.sendparamsDto.operatorType = 200;
        let res = await this.$store.dispatch({
            type: "meter/meterControl",
            data: this.sendparamsDto,
        });
        console.log(res)
        this.$Modal.info({
            title: this.L("Tips"),
            content: res,
        });
    }
    /**
     * 设置密钥
     */
    async setAesKey() {
        this.sendparamsDto.operatorType = 222;
        let res = await this.$store.dispatch({
            type: "meter/meterControl",
            data: this.sendparamsDto,
        });
        this.$Modal.info({
            title: this.L("Tips"),
            content: res,
        });
    }
    /**
     * 设置恶性负载
     */
    async setLimitPower() {
        this.sendparamsDto.operatorType = 309;
        let res = await this.$store.dispatch({
            type: "meter/meterControl",
            data: this.sendparamsDto,
        });
        this.$Modal.info({
            title: this.L("Tips"),
            content: res,
        });
    }
    /**
     * 获取定时数据
     */
    async getMeterTiming() {
        let timingData = { deviceId: this.sendparamsDto.deviceIds[0] };
        let res = await this.$store.dispatch({
            type: "metertiming/getAll",
            data: timingData,
        });
        this.columnsdata = [];
        this.indexnum = 1;
        res.items.forEach(ele => {
            //let tmp = ele;
            ele.indexNo = this.indexnum;
            //this.columnsdata.push(tmp);
            this.indexnum++;
        });
        this.indexnum--;
        this.columnsdata = res.items;
    }
    /**保存数据 */
    save() {
        (this.$refs.itemForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.loading = true;
                (this.$refs.itemForm as any).resetFields();
                this.$emit("save-success");
                this.$emit("input", false);
                this.loading = false;
            }
        });
    }
    cancel() {
        (this.$refs.itemForm as any).resetFields();
        this.$emit("input", false);
    }
    /**
     * 界面显示
     */
    async visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        }
        await this.getMeterTiming();
    }
    /**
     * 检测Ip地址
     * @param value 
     */
    validateIP(value) {
        let str = commandHelper.validateIP(value)
        if (!str) {
            this.$Notice.warning({
                title: this.L("Tips"),
                desc: 'Ip地址异常'
            });
        }
    }
    /**
     * 设置ip地址
     */
    async setIpAddress() {
        if (!commandHelper.validateIP(this.sendparamsDto.masterIp)) {
            this.$Notice.warning({
                title: this.L("Tips"),
                desc: this.L('MasterIpIsError')
            });
            return;
        }
        if (this.sendparamsDto.masterPort == null || this.sendparamsDto.masterPort < 0) {
            this.$Notice.warning({
                title: this.L("Tips"),
                desc: this.L('MasterPortIsError')
            });
            return;
        }
        if (!commandHelper.validateIP(this.sendparamsDto.standbyIp)) {
            this.$Notice.warning({
                title: this.L("Tips"),
                desc: this.L('StandByIpIsError')
            });
            return;
        }
        if (this.sendparamsDto.standbyPort == null || this.sendparamsDto.standbyPort < 0) {
            this.$Notice.warning({
                title: this.L("Tips"),
                desc: this.L('StandByPortIsError')
            });
            return;
        }
        this.sendparamsDto.operatorType = 203;
        let res = await this.$store.dispatch({
            type: "meter/meterControl",
            data: this.sendparamsDto,
        });
        this.$Modal.info({
            title: this.L("Tips"),
            content: res,
        });
    }
    itemRule = {
        targetOrgId: [
            {
                type: 'number',
                required: true,
                message: this.L("PleasChoose") + this.L("Organizations"),
                trigger: "blur",
            },
        ],
    };
    async organizationlist() {
        await this.$store
            .dispatch("organization/getselectTree")
            .then((val) => {
                this.$data.optionsMechanism = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    data() {
        return {
            optionsMechanism: [],
            sendUnit: [
                { value: 1, label: '分' },
                { value: 2, label: '时' },
                { value: 3, label: '日' },
                { value: 4, label: '月' },
            ],
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
        };
    }
    @Watch("meterlist", { deep: true })
    @Watch("meternolist", { deep: true })
    getitemId() {
        this.sendparamsDto.deviceIds = this.meterlist;
        if (this.meternolist.length > 0) {
            this.sendparamsDto.meterNoList = "";
            let num = 0;
            this.meternolist.forEach((ele) => {
                if (num == 0) {
                    this.sendparamsDto.meterNoList = ele;
                } else {
                    this.sendparamsDto.meterNoList =
                        this.sendparamsDto.meterNoList + ";" + ele;
                }
                num++;
            });
        }
    }
}
